export default __webpack_public_path__ + "static/media/blueCircleDollarBold.6b97a356.svg";